<template>
  <div id="func-0">
    <FuncionalidadeHeader :titulo="funcionalidade.nome"/>
    <el-row>
      <el-col :span="14" style="margin-right: 32px;">
        <h1 class="titulo-noticia">{{ noticia.titulo }}</h1>
        <div class="detalhes">
          <span class="data">{{ formatData(noticia.data) }}</span>
          <span v-for="(categoria, index) in noticia.categorias_nomes" :key="index">{{ categoria }}</span>
        </div>
        <div class="midia">
          <el-image v-if="noticia.foto_principal_url && !noticia.galeria_fotos && !noticia.video" class="foto-principal" :src="noticia.foto_principal_url"/>
          <video v-if="noticia.video && noticia.video.video_url" controls :src="noticia.video.video_url"></video>
          <div v-if="noticia.video && noticia.video.embed" v-html="noticia.video.embed" class="video-embed"></div>
          <audio v-if="noticia.podcast" controls>
            <source :src="noticia.podcast.url"/>
          </audio>
          <div v-if="noticia.galeria_fotos" class="galeria-fotos">
            <el-carousel trigger="click" arrow="always" :autoplay="false" indicator-position="none" ref="galeria" @change="changeAtivo">
              <el-image class="tela-cheia" :src="iconeTelaCheia" :preview-src-list="urlImgs" :z-index="999999"/>
              <el-carousel-item v-for="(img, index) in noticia.galeria_fotos" :key="index">
                <img :src="img.url"/>
                <span class="descricao" v-if="img.titulo">{{ img.titulo }}</span>
              </el-carousel-item>
            </el-carousel>
            <li class="list-imagens">
              <ul v-for="(img, index) in noticia.galeria_fotos" :key="index" @click="changeCarousel(index)">
                <img v-if="index === indexAtivo" :src="img.url" :style="estiloBorda"/>
                <img v-else :src="img.url"/>
              </ul>
            </li>
          </div>
        </div>
        <p class="conteudo" v-html="noticia.conteudo"></p>
        <el-row v-if="noticia.galeria_arquivos">
          <h1 class="subtitulos">Arquivos para download</h1>
          <div v-for="(arquivo, index) in noticia.galeria_arquivos"
               :key="index" class="arquivos"
               :style="estiloFundo"
          >
            <span class="titulo">{{ arquivo.titulo }}</span>
            <span>{{ arquivo.tamanho }}
              <span class="download" :style="estiloCor"  @click="downloadArquivo(arquivo)">DOWNLOAD<i class="el-icon-download"/></span>
            </span>
          </div>
        </el-row>
        <ButtonDefault title="Mais Notícias"
                       @click="goToListNoticias"
                       :small="true"
                       :secundario="true"
                       :border="true"/>
      </el-col>
      <el-col :span="8" class="outras-noticias">
        <h1 class="subtitulos">Leia também</h1>
        <NoticiasCard v-for="(noticia, index) in noticias" :item="noticia" @click="goToNoticia(noticia.id)" :key="index"/>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import moment from 'moment'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import NoticiasCard from '@/components/cards/NoticiasCard'
import { forceDownloadBase64 } from '@/utils/Download'
import { urlIcons } from '@/utils/ImageBucket'
import { emmitTrocarPagina } from '@/utils/comandosSdk'

export default {
  name: 'Func0Detalhe',
  components: {
    FuncionalidadeHeader,
    ButtonDefault,
    NoticiasCard
  },
  data () {
    return {
      idNoticia: '',
      noticias: [],
      noticia: {},
      indexAtivo: 0
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    estiloFundo () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloCor () {
      return {
        color: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    estiloBorda () {
      return {
        border: `3px solid ${this.estilo.aplicacao.corPrimariaAplicacao}`,
        width: '50px',
        height: '50px'
      }
    },
    iconeTelaCheia () {
      return urlIcons('icon-map_expand')
    },
    urlImgs () {
      const urls = []
      this.noticia.galeria_fotos.forEach(foto => {
        urls.push(foto.url)
      })
      return urls.splice(this.indexAtivo).concat(urls)
    }
  },
  methods: {
    async init () {
      this.idNoticia = parseInt(this.$route.query.idNoticia) || parseInt(this.$route.query.idRegistro)
      await this.getDetalhes()
      await this.getNoticias()
      this.comandoTrocaDePagina(`${this.funcionalidade.nome} - ${this.noticia.titulo}`)
    },
    async getDetalhes () {
      const result = await this.apiFuncionalidade.detalhe({
        payload: {
          postId: this.idNoticia
        },
        loading: true,
        handlerErrorIgnore: [404]
      })

      if (result) {
        this.noticia = result.data[0]
      }
    },
    async getNoticias () {
      const result = await this.apiFuncionalidade.lista({
        payload: {
          postTipoId: this.funcionalidade.parametros.postTipoId,
          numItens: this.funcionalidade.parametros.numItemLista,
          offset: 0
        },
        loading: true,
        handlerErrorIgnore: [404]
      })

      if (result) {
        const data = result.data
        const index = data.findIndex(not => not.id === this.idNoticia)
        data.splice(index, 1)
        this.noticias = data.slice(0, 5)
      } else {
        this.noticias = []
      }
    },
    formatData (data) {
      return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    goToListNoticias () {
      return this.$router.push({
        path: '/0'
      })
    },
    goToNoticia (id) {
      this.$router.push({
        path: '/0/detalhe',
        query: { idNoticia: id }
      })
      this.init()
    },
    async downloadArquivo (arquivo) {
      await forceDownloadBase64({
        nome: `${arquivo.titulo}.pdf`,
        url: arquivo.url
      })
    },
    changeCarousel (index) {
      this.$refs.galeria.setActiveItem(index)
      this.indexAtivo = index
    },
    changeAtivo (newIndex) {
      this.indexAtivo = newIndex
    },
    comandoTrocaDePagina (titulo) {
      emmitTrocarPagina(this.frameId, titulo)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less">
.el-image-viewer__mask {
  background: white;
  opacity: .9;
}

#func-0 {
  .titulo-noticia {
    font-family: Noto Serif;
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 20px;
  }

  .galeria-fotos {
    width: 100%;
    margin-top: 20px;

    .tela-cheia {
      position: absolute;
      z-index: 99;
      top: 10px;
      right: 20px;
      height: 40px;
      width: 40px;
      border-radius: 100%;
      background: #0000002d;
      text-align: center;

      img {
        width: 14px;
      }
    }

    .el-carousel__item {
      text-align: center;

      img {
        height: auto;
        max-height: 330px;
        width: auto;
        max-width: 100%;
      }
    }

    .descricao {
      position: absolute;
      z-index: 99;
      bottom: 0;
      left: 0;
      right: 0;
      background: #0000006d;
      color: #FFFFFF;
      height: 44px;
      text-align: left;
      padding: 5px 0 0 15px;
      font-size: 12px;
      line-height: 17px;
    }

    .el-carousel__arrow {
      font-size: 46px;
      width: 46px;
      height: 46px;
      background: none;

      i {
        vertical-align: top;
        text-shadow: 0 0 10px #000000b3;
      }
    }

    .list-imagens {
      display: flex;
      flex-wrap: wrap;
      ul {
        width: 55px;
        height: 55px;
        margin: 10px 5px 0;
        padding: 0;

        img {
          width: 55px;
          height: 55px;
          border-radius: 10px;
        }
      }
    }
  }

  .midia {
    margin-top: 20px;
    border-radius: 10px;
    text-align: center;

    video {
      border-radius: 10px;
      width: 100%;
    }

    .video-embed {
      display: flex;
    }

    audio {
      width: 100%;
      background: #F6F6F6;
      border-radius: 10px;
      -webkit-text-fill-color: #555555;
    }

    audio::-webkit-media-controls-panel {
      background: #F6F6F6;
    }

    .foto-principal {
      width: 100%;
      border-radius: 10px;
      margin-bottom: 20px;

      img{
        height: auto;
      }
    }
  }

  .conteudo {
    margin: 20px 0 30px;
    font-family: Noto Serif;
    font-size: 18px;
    line-height: 30px;
    word-wrap: break-word;
  }

  .subtitulos {
    font-size: 20px;
    line-height: 27px;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .arquivos {
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 15px;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    .titulo {
      font-weight: 600;
      margin: 0 58px 0 0;
      max-width: 263px;
      word-break: break-word;
    }

    .download {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      margin-left: 20px;
      cursor: pointer;

      i {
        margin-left: 5px;
        font-weight: bold;
      }
    }
  }

  .outras-noticias {
    .noticia {
      p {
        font-size: 16px !important;
        line-height: 22px !important;
      }
      img {
        max-height: 73px !important;
        max-width: 130px !important;
      }
    }
  }
}
</style>
